<template>
  <NuxtLayout name="default">
    <div class="home_container">
      <div
        :style="{
          'background-image': 'url(' + OSS_BUCKET_URL + '/assets/images/bg.jpg)'
        }"
        class="top">
        <div class="top_container">
          <div class="slogan">{{ $t('home.top_container.slogan') }}</div>
          <div class="search_count">
            <el-input
              v-model="keyword"
              :class="keywordError ? 'keyword-error' : ''"
              :placeholder="keywordPlaceholder"
              @input="handleKeywordInput"
              @keyup.enter.native="handleSearch" />
            <el-button
              class="search-btn"
              :icon="Search"
              :aria-label="$t('common.search')"
              @click="handleSearch" />
          </div>
          <div class="hot_city">
            <div class="cities_label">{{ $t('home.hot_city.title') }}</div>
            <div class="cities">
              <!-- 上海 深圳 广州 北京 法兰克福 科隆 香港 东京 -->
              <a
                :title="$t('home.hot_city.city1_hover')"
                href="/exhibition-0-0-1-519-1123-0-1/"
                target="_blank">
                {{ $t('home.hot_city.city1') }}
              </a>
              <a
                :title="$t('home.hot_city.city2_hover')"
                href="/exhibition-0-0-1-528-1252-0-1/"
                target="_blank">
                {{ $t('home.hot_city.city2') }}
              </a>
              <a
                :title="$t('home.hot_city.city3_hover')"
                href="/exhibition-0-0-1-528-1250-0-1/"
                target="_blank">
                {{ $t('home.hot_city.city3') }}
              </a>
              <a
                :title="$t('home.hot_city.city4_hover')"
                href="/exhibition-0-0-1-11-1051-0-1/"
                target="_blank">
                {{ $t('home.hot_city.city4') }}
              </a>
              <a
                :title="$t('home.hot_city.city5_hover')"
                href="/exhibition-0-0-1-26-1449-0-1/"
                target="_blank">
                {{ $t('home.hot_city.city5') }}
              </a>
            </div>
          </div>
        </div>
        <div class="kind">
          <SectionTitle
            :title="$t('home.kindTitle')"
            style="font-size: 18px; font-weight: bold" />
          <div class="industry_container">
            <div
              v-for="(item, idx) in industry"
              :key="item.industryId"
              class="item">
              <div class="item_inner">
                <div class="item_value">{{ item.industryName }}</div>
              </div>
              <span class="arrow"></span>
              <div
                :style="subIndustry(idx)"
                class="hover_content">
                <nuxt-link
                  v-for="two in item.children"
                  :key="two.id"
                  :to="`/exhibition-${two.pid}-${two.id}-1-0-0-0-1/`"
                  class="hover_content_item"
                  target="_blank">
                  {{ two.industryName }}
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Banner -->
      <div
        v-if="banner.length > 0"
        class="banner-area">
        <el-carousel
          :interval="3000"
          autoplay
          height="290px"
          indicator-position="none"
          type="card">
          <el-carousel-item
            v-for="item in banner.slice(0, 6)"
            :key="item.url">
            <a
              :href="item.link"
              class="inline-block"
              target="_blank"
              title="Banner">
              <el-image
                :src="item.url"
                alt="banner"
                class="banner-img"
                loading="lazy" />
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hot_recommend">
        <div class="hot_title">
          <img
            alt="hot"
            loading="lazy"
            rel="nofollow,noindex"
            src="../../assets/icon/fire.png" />
          <div>{{ $t('home.hot_recommend.hot_title') }}</div>
          <div class="more">
            <nuxt-link
              :title="$t('home.hot_recommend.international_hover')"
              class="row-flex align-content-c"
              target="_blank"
              to="/exhibition/?sort=hot">
              {{ $t('home.hot_recommend.moreButton') }}
              <el-icon>
                <ElIconArrowRight />
              </el-icon>
            </nuxt-link>
          </div>
        </div>
        <el-carousel
          :interval="5000"
          direction="vertical"
          height="390px"
          indicator-position="none">
          <el-carousel-item
            v-for="idx in 5"
            :key="idx">
            <div class="recommend_list">
              <Goods
                v-for="item in get(hotFair, 'records', []).slice((idx - 1) * 4, idx * 4)"
                :key="item.id"
                :data="item"
                class="goods_exh"
                is-hot />
            </div>
          </el-carousel-item>
        </el-carousel>
        <!--国内展会-->

        <div
          v-if="banner.length > 6"
          class="banner-area">
          <div
            v-for="item in banner.slice(6, 7)"
            class="banner-tag">
            <a
              :href="item.link"
              target="_blank">
              <el-image
                :src="item.url"
                alt="banner"
                class="banner-img"
                loading="lazy" />
            </a>
          </div>
        </div>
        <!--      国际展会-->
        <div class="title_more">
          <SectionTitle
            :title="$t('home.hot_recommend.internationalTitle')"
            style="font-size: 20px; font-weight: bold" />
          <div class="more">
            <nuxt-link
              :title="$t('home.hot_recommend.international_hover')"
              target="_blank"
              to="/exhibition-0-0-0-0-0-0-1/">
              {{ $t('home.hot_recommend.moreButton') }}
              <el-icon>
                <ElIconArrowRight />
              </el-icon>
            </nuxt-link>
          </div>
        </div>
        <div class="china_exh">
          <!-- 德国 -->
          <div class="exh_content">
            <el-image
              :alt="$t('home.hot_city.city6')"
              :src="`${OSS_BUCKET_URL}/assets/images/home/deGuo.png`"
              class="exh_bg"
              loading="lazy" />
            <div class="exh_list">
              <EveFair :list="dgFair.records" />
            </div>
          </div>
          <!-- 日本 -->
          <div class="exh_content">
            <el-image
              :alt="$t('home.hot_city.city7')"
              :src="`${OSS_BUCKET_URL}/assets/images/home/riBen.png`"
              class="exh_bg"
              loading="lazy" />
            <div class="exh_list">
              <EveFair :list="rbFair.records" />
            </div>
          </div>
          <!-- 美国 -->
          <div class="exh_content">
            <el-image
              :alt="$t('home.hot_city.city8')"
              :src="`${OSS_BUCKET_URL}/assets/images/home/meiGuo.png`"
              class="exh_bg"
              loading="lazy" />
            <div class="exh_list">
              <EveFair :list="mgFair" />
            </div>
          </div>
        </div>

        <div
          v-if="banner.length > 7"
          class="banner-area">
          <div
            v-for="item in banner.slice(7, 8)"
            class="banner-tag">
            <a
              :href="item.link"
              target="_blank">
              <el-image
                :src="item.url"
                alt="banner"
                class="banner-img"
                loading="lazy" />
            </a>
          </div>
        </div>
        <div class="title_more">
          <SectionTitle
            :title="$t('home.hot_recommend.domesticTitle')"
            style="font-size: 20px; font-weight: bold" />
          <div class="more">
            <nuxt-link
              :title="$t('home.hot_recommend.domestic_hover')"
              target="_blank"
              to="/exhibition-0-0-1-0-0-0-1/">
              {{ $t('home.hot_recommend.moreButton') }}
              <el-icon>
                <ElIconArrowRight />
              </el-icon>
            </nuxt-link>
          </div>
        </div>
        <div class="china_exh">
          <!-- 上海 -->
          <div class="exh_content">
            <el-image
              :alt="$t('home.hot_city.city1')"
              :src="`${OSS_BUCKET_URL}/assets/images/home/Shanghai.png`"
              class="exh_bg"
              loading="lazy" />
            <div class="exh_list">
              <EveFair :list="shFair.records" />
            </div>
          </div>
          <!-- 北京 -->
          <div class="exh_content">
            <el-image
              :alt="$t('home.hot_city.city4')"
              :src="`${OSS_BUCKET_URL}/assets/images/home/beiJing.png`"
              class="exh_bg"
              loading="lazy" />
            <div class="exh_list">
              <EveFair :list="bjFair.records" />
            </div>
          </div>
          <!-- 深圳 -->
          <div class="exh_content">
            <el-image
              :alt="$t('home.hot_city.city2')"
              :src="`${OSS_BUCKET_URL}/assets/images/home/shenZhen.png`"
              class="exh_bg"
              loading="lazy" />
            <div class="exh_list">
              <EveFair :list="szFair.records" />
            </div>
          </div>
        </div>

        <div
          v-if="banner.length > 8"
          class="banner-area">
          <div
            v-for="item in banner.slice(8, 9)"
            class="banner-tag">
            <a
              :href="item.link"
              target="_blank">
              <el-image
                :src="item.url"
                alt="banner"
                class="banner-img"
                loading="lazy" />
            </a>
          </div>
        </div>
        <!--最新动态-->
        <div class="title_more">
          <SectionTitle
            :title="$t('home.hot_recommend.newTrends_title')"
            style="font-size: 20px; font-weight: bold" />
          <div class="more">
            <nuxt-link
              :title="$t('home.hot_recommend.exhibitionInfo_hover')"
              target="_blank"
              to="/information/">
              {{ $t('home.hot_recommend.moreButton') }}
              <el-icon>
                <ElIconArrowRight />
              </el-icon>
            </nuxt-link>
          </div>
        </div>
        <div class="news_exh">
          <!--最新资讯-->
          <div class="news_count new-news">
            <div class="news_tit">
              <span class="tit_icon">
                <img
                  alt="news"
                  src="../../assets/icon/time1.png" />
                <span>{{ $t('home.hot_recommend.nuwInfo_title') }}</span>
              </span>
            </div>
            <div
              v-if="news && news.length"
              class="news-list-box">
              <NewsList :data="news.slice(0, 5)" />
              <NewsList
                :data="news.slice(5, 10)"
                :idx="6" />
            </div>
          </div>
          <!--展会政策-->
          <div class="news_count">
            <div class="news_tit">
              <span class="tit_icon">
                <img
                  :alt="$t('menu.exhibitionInfo')"
                  src="../../assets/icon/major.png" />
                <span>{{ $t('home.hot_recommend.newExhibition_title') }}</span>
              </span>
            </div>
            <NewsList
              :data="policyNews.slice(0, 5)"
              type="fair" />
          </div>
        </div>
        <div class="hot_country">
          <div class="tab_head row-flex">
            <div
              :class="{ active: innerChainActive == 0 }"
              class="tab_name"
              @click="handleHotTab(0)">
              {{ $t('home.popularRegions') }}
            </div>
            <div
              :class="{ active: innerChainActive == 1 }"
              class="tab_name"
              @click="handleHotTab(1)">
              {{ $t('home.hotIndustries') }}
            </div>
            <div
              :class="{ active: innerChainActive == 2 }"
              class="tab_name"
              @click="handleHotTab(2)">
              {{ $t('home.topExhibitions') }}
            </div>
          </div>
          <div class="country_list">
            <div
              v-show="innerChainActive == 0"
              class="tab_content row-flex-wrap">
              <a
                v-for="item in innerChainAreaList"
                :key="item.id"
                :href="item.url"
                :title="item.content"
                target="_blank">
                <template v-if="!lang || lang == 'cn'">
                  {{ item.content }}
                </template>
                <template v-else>
                  {{ item.countryEnglishName }}
                </template>
              </a>
            </div>
            <div
              v-show="innerChainActive == 1"
              class="tab_content row-flex-wrap">
              <a
                v-for="item in innerChainIndustryList"
                :key="item.id"
                :href="item.url"
                :title="item.content"
                target="_blank">
                <template v-if="!lang || lang == 'cn'">
                  {{ item.content }}
                </template>
                <template v-else>
                  {{ item.countryEnglishName }}
                </template>
              </a>
            </div>
            <div
              v-show="innerChainActive == 2"
              class="tab_content row-flex-wrap">
              <a
                v-for="item in innerChainExhList"
                :key="item.id"
                :href="item.url"
                :title="item.content"
                target="_blank">
                <template v-if="!lang || lang == 'cn'">
                  {{ item.content }}
                </template>
                <template v-else>
                  {{ item.countryEnglishName }}
                </template>
              </a>
            </div>
          </div>
        </div>
        <div class="service row-flex-wrap">
          <div class="ser_item">
            <img
              :alt="$t('home.hot_recommend.service_1')"
              :src="`${OSS_BUCKET_URL}/assets/icon/service1.png`" />
            <div>{{ $t('home.hot_recommend.service_1') }}</div>
          </div>
          <div class="ser_item">
            <img
              :alt="$t('home.hot_recommend.service_2')"
              :src="`${OSS_BUCKET_URL}/assets/icon/service2.png`" />
            <div>{{ $t('home.hot_recommend.service_2') }}</div>
          </div>
          <div class="ser_item">
            <img
              :alt="$t('home.hot_recommend.service_3')"
              :src="`${OSS_BUCKET_URL}/assets/icon/service3.png`" />
            <div>{{ $t('home.hot_recommend.service_3') }}</div>
          </div>
          <div class="ser_item">
            <img
              :alt="$t('home.hot_recommend.service_4')"
              :src="`${OSS_BUCKET_URL}/assets/icon/service4.png`" />
            <div>{{ $t('home.hot_recommend.service_4') }}</div>
          </div>
          <div class="ser_item">
            <img
              :alt="$t('home.hot_recommend.service_5')"
              :src="`${OSS_BUCKET_URL}/assets/icon/service5.png`" />
            <div>{{ $t('home.hot_recommend.service_5') }}</div>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, onMounted } from 'vue'
  import { checkDevice, getWhiteScreenTime, handleApiError, OSS_BUCKET_URL } from '~/utils/common'
  import { TraceCode } from '~/utils/trace'
  import { Search } from '@element-plus/icons-vue'
  import { useHome } from '~/composables/home/useHome'

  const Goods = defineAsyncComponent(() => import('~/components/Goods/index.vue'))
  const EveFair = defineAsyncComponent(() => import('~/views/home/components/EveFair.vue'))
  const NewsList = defineAsyncComponent(() => import('~/views/home/components/NewsList.vue'))
  const SectionTitle = defineAsyncComponent(() => import('~/components/SectionTitle/index.vue'))

  const {
    $t,
    keyword,
    keywordError,
    keywordPlaceholder,
    innerChainActive,
    lang,
    apiErrorList,
    industry,
    banner,
    hotFair,
    shFair,
    bjFair,
    szFair,
    dgFair,
    rbFair,
    mgFair,
    news,
    policyNews,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    handleSearch,
    handleHotTab,
    handleKeywordInput,
    subIndustry,
    get
  } = await useHome(ELocale.cn)

  useHead({
    title: $t('tdk.home.title'),
    meta: [
      {
        name: 'mobile-agent',
        'http-equiv': 'mobile-agent',
        content: 'format=html5; url=https://m.jufair.com'
      },
      {
        name: 'keywords',
        content: $t('tdk.home.keywords')
      },
      {
        name: 'description',
        content: $t('tdk.home.description')
      }
    ]
  })

  onMounted(() => {
    getWhiteScreenTime()
    if (checkDevice() == 'h5') {
      let url = `https://m.jufair.com`
      window.location.replace(url)
    }

    handleApiError(apiErrorList.value)
    // console.log('???', window.trace);
    window.trace?.upload({
      module: TraceCode.MO_HOME
    })
  })
</script>

<style lang="less">
  .home_container {
    .top {
      height: 480px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      margin-bottom: 160px;
      position: relative;
      background-color: rgba(90, 143, 205, 0.5);

      .top_container {
        position: absolute;
        top: 120px;
        left: calc(50% - 350px);

        .slogan {
          margin-bottom: 21px;
          font-size: 36px;
          font-weight: bold;
          color: #fff;
          text-shadow: 0 2px 4px rgba(45, 129, 157, 0.58);
        }

        .search_count {
          width: 700px;
          height: 56px;
          margin-bottom: 15px;
          border-radius: 6px;
          position: relative;

          .el-input__inner {
            height: 56px;
            font-size: 16px;
            color: #333;
            padding-right: 53px;

            &::placeholder {
              color: #777;
            }
          }

          .keyword-error {
            .el-input__inner {
              border: 1px solid #f00;
              color: #f00;

              &::placeholder {
                color: #f00;
              }
            }
          }

          .search-btn {
            position: absolute;
            width: 53px;
            height: 54px;
            top: 1px;
            right: 2px;
            background: #fff;
            border: none;
            font-size: 20px;
          }
        }

        .hot_city {
          display: flex;

          .cities_label,
          .cities {
            font-size: 16px;
            color: #fff;
            font-weight: bold;

            a {
              color: #fff;
              margin-right: 8px;

              &:hover {
                color: @app-color;
              }
            }
          }

          .cities {
            font-weight: 600;
          }
        }
      }

      .kind {
        width: 1190px;
        background: #fff;
        border-radius: 10px;
        position: absolute;
        top: 369px;
        left: calc(50% - 595px);
        padding: 14px 28px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);

        .industry_container {
          padding: 28px 15px 28px 15px;
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 0;

          .item {
            display: flex;
            margin-right: 32px;
            padding-bottom: 20px;
            flex-flow: column;
            position: relative;

            .arrow {
              display: none;
              position: absolute;
              top: 10px;
              left: calc(50% - 7px);
              width: 0;
              height: 0;
              border: 7px solid;
              border-color: transparent transparent #ddd;
            }

            &:hover {
              .hover_content {
                display: flex;
                flex-flow: wrap;
              }

              .arrow {
                display: block;
              }
            }

            .item_inner {
              display: flex;

              &:hover {
                cursor: pointer;
              }
            }

            // &:nth-child(5n) {
            //   margin-right: 0;
            // }

            .industry-icon {
              width: 19px;
              height: 20px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                width: auto;
                max-width: 19px;
                height: 20px;
              }
            }

            .item_value {
              font-size: 16px;
              color: #333;
              max-width: 152px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .hover_content {
              position: absolute;
              width: 600px;
              top: 25px;
              z-index: 10;
              display: none;
              padding: 16px 24px 8px;
              background: #fff;
              box-shadow:
                0 4px 4px rgba(10, 16, 20, 0.12),
                0 0 4px rgba(10, 16, 20, 0.12);
              border-radius: 6px;
              box-sizing: border-box;
              // &::before {
              //   position: absolute;
              //   top: -14px;
              //   left: calc(50% - 7px);
              //   content: '';
              //   width: 0;
              //   height: 0;
              //   border: 7px solid;
              //   border-color: transparent transparent red;
              // }
              .hover_content_item {
                font-size: 15px;
                margin-right: 15px;
                margin-bottom: 8px;

                &:hover {
                  color: #e50113;
                }
              }
            }
          }
        }
      }
    }

    .banner-area {
      width: 1190px;
      margin: 22px auto;

      .el-carousel__item {
        width: 600px;
        border-radius: 6px;
        overflow: hidden;

        .banner-img {
          width: 600px;
          border-radius: 6px;
        }
      }

      .banner-tag {
        > a {
          display: inline-block;

          > img {
            width: 1190px;
            border-radius: 6px;
          }
        }
      }
    }

    .hot_recommend {
      width: 1190px;
      margin: 22px auto;

      .hot_title {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        display: flex;
        margin-bottom: 22px;
        align-items: center;

        img {
          width: 26px;
          margin-right: 8px;
        }

        .more {
          margin-left: auto;
          font-size: 16px;
          font-weight: 400;
          color: #333;
        }
      }

      .title_more {
        display: flex;
        margin-top: 25px;
        margin-bottom: 18px;

        .more {
          margin-left: auto;
          font-size: 16px;
          font-weight: 400;
          color: #333;
        }
      }

      .recommend_list {
        display: flex;

        .goods_exh {
          margin-right: 12px;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .china_exh {
        display: flex;
        justify-content: space-between;

        .exh_content {
          position: relative;
          width: 388px;
          padding-top: 117px;

          .exh_bg {
            width: 100%;
            position: absolute;
            top: 0;
            z-index: 1;
          }

          .exh_list {
            width: 362px;
            position: relative;
            left: calc(50% - 181px);
            z-index: 2;
            min-height: 39px;
          }
        }
      }

      .news_exh {
        display: flex;
        justify-content: space-between;

        .news_count {
          width: 384px;
          background: #fff;
          border-radius: 6px;
          padding: 22px 28px 32px;
        }

        .news_tit {
          font-size: 18px;
          font-weight: bold;
          color: #333;
          position: relative;
          margin-bottom: 18px;

          &::before {
            content: '';
            width: 100px;
            height: 2px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: @app-color;
            z-index: 3;
          }

          .tit_icon {
            position: relative;
            display: flex;
            align-items: center;
            // width: 100px;
            border-bottom: 2px solid #d0d0d0;
            padding-bottom: 11px;
            z-index: 2;

            img {
              margin-right: 5px;
            }
          }
        }

        .news-list-box {
          display: flex;
          gap: 24px;
        }

        .new-news {
          width: 794px;

          .news_list {
            width: 50%;

            .name {
              width: 298px;
            }
          }
        }
      }

      .hot_country {
        margin-top: 12px;
        padding: 20px 39px;
        background: #fff;
        border-radius: 6px;

        .tab_head {
          gap: 10px 20px;
          margin-bottom: 10px;

          .tab_name {
            padding-bottom: 3px;
            font-size: 15px;
            border-bottom: solid 2px #fff;

            &.active {
              border-bottom: solid 2px @app-color;
            }

            &:hover {
              cursor: pointer;
            }
          }
        }

        .tab_content {
          gap: 10px;
        }

        .country_list {
          a {
            font-size: 15px;
            color: #333;
            min-width: 129px;
            // margin-right: 20px;
            // margin-bottom: 10px;

            &:nth-child(8n) {
              margin-right: 0;
            }
          }
        }
      }

      .service {
        margin-top: 12px;
        background: #fff;
        border-radius: 6px;
        padding: 23px 68px;
        display: flex;
        justify-content: space-between;

        .ser_item {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: bold;
          color: #333;

          img {
            width: 23px;
            margin-right: 7px;
          }
        }
      }
    }
  }
</style>
